import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { Section } from '../../Section';
import { Carousel } from '../../Carousel';
import { ManagementCompany } from '../../Products';
export var FundLocalManagementCompanies = function FundLocalManagementCompanies(_ref) {
  var productType = _ref.productType,
    managementCompanies = _ref.managementCompanies;
  var topLocalManagementCompanies = managementCompanies.items.filter(function (element) {
    return element.country === 'ESP' && element.organization && element.organization.id;
  });
  return React.createElement(Section, {
    title: "Gestoras nacionales",
    bottomMargin: true
  }, React.createElement(Carousel, {
    breakpoints: [{
      screen: 'miniPhone',
      items: 2.5
    }, {
      screen: 'phone',
      items: 3.2
    }, {
      screen: 'phablet',
      items: 3.8
    }, {
      screen: 'tablet',
      items: 4.8
    }, {
      screen: 'miniDesktop',
      items: 6.5
    }]
  }, topLocalManagementCompanies.map(function (company) {
    return React.createElement(ManagementCompany, {
      variant: "mediumCard",
      key: company.id,
      managementCompany: company,
      productType: productType
    });
  })));
};